"use client";

import { c as _c } from "react/compiler-runtime";
import { SidebarTrigger } from "@/components/ui/sidebar";
export function SkillsHeader() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <header className="bg-background flex items-center border-b p-4"><div className="flex min-w-0 flex-1 items-center gap-3"><SidebarTrigger /><span className="text-lg font-medium">Skills</span></div></header>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}